import * as tslib_1 from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '../../Button';
import IframePopup from '../../IframePopup';
import s from '../../IframePopup/IframePopup.scss';
var ReportPopup = /** @class */ (function (_super) {
    tslib_1.__extends(ReportPopup, _super);
    function ReportPopup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            step: 'iframe',
        };
        _this.onMessage = function (_a) {
            var origin = _a.origin, data = _a.data;
            // TODO: check origin
            var _b = _this.props, requestClose = _b.requestClose, onBlocked = _b.onBlocked, deviationId = _b.deviationId;
            try {
                var _c = JSON.parse(data), _type = _c._type, eventname = _c.eventname, payload = _c.payload;
                if (_type !== 'PubSubEvent' || !eventname) {
                    return;
                }
                switch (eventname) {
                    case 'ModerationForm.reloadPage':
                        onBlocked(deviationId);
                        if (payload && payload.reportSubmitted) {
                            _this.setState({
                                step: 'success',
                            });
                        }
                        else {
                            requestClose();
                        }
                        return;
                    case 'ModerationForm.showSuccessModal':
                        _this.setState({
                            step: 'success',
                        });
                        break;
                    case 'ModerationForm.showErrorModal':
                        _this.setState({
                            step: 'fail',
                        });
                        break;
                    case 'ModerationForm.closeModal':
                        requestClose();
                        break;
                    default:
                    // do nothing
                }
            }
            catch (_d) {
                return;
            }
        };
        return _this;
    }
    ReportPopup.prototype.render = function () {
        var _a = this.props, reportUrl = _a.reportUrl, t = _a.t;
        var step = this.state.step;
        switch (step) {
            case 'fail':
                return this.renderConfirmation(t('moderation.error'), t('moderation.tryLater'));
            case 'success':
                return this.renderConfirmation(t('moderation.reportSubmitted'), t('moderation.reviewSoon'));
            case 'iframe':
            default:
                return (React.createElement(IframePopup, { initialWidth: 500, initialHeight: 390, src: reportUrl, onMessage: this.onMessage }));
        }
    };
    ReportPopup.prototype.renderConfirmation = function (title, description) {
        var _a = this.props, requestClose = _a.requestClose, t = _a.t;
        return (React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: s['title'] }, title),
            React.createElement("div", { className: s['description'] }, description),
            React.createElement(Button, { onClick: requestClose, className: s['footer-button'] }, t('common.done'))));
    };
    return ReportPopup;
}(React.Component));
export { ReportPopup };
export default withTranslation()(ReportPopup);
//# sourceMappingURL=ReportPopup.js.map